/**
 * Konvertuje admin nastavenou hodnotu (50-200 %) na multiplikator pro velikost loga.
 * Null/undefined -> 1.0 (default 100 %).
 * Clampuje mimo rozsah, aby nikdo nerozbil layout extremni hodnotou.
 */
export const logoScale = (pct: number | null | undefined): number => {
  const v = pct ?? 100;
  return Math.max(0.5, Math.min(2, v / 100));
};
